module.exports = {"id":"192955","name":"Mateusz Klich","rating":"72","photo":"./data/images/photos/4/192955.png","club":{"name":"FC Utrecht","logo":"./data/images/clubs/FCUtrecht.png"},"positions":["MC","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MateuszKlich0.json
// module id = 2856
// module chunks = 0